// import { darken } from '@material-ui/core/styles';
import * as palette from './colors';
import {
  typographyVariants,
  customTypographyVariants,
  fontStack
} from './typography';
import { shadows } from './shadows';

const variants = {
  'Mui-SaveAndExitLeftPanel': {
    root: {
      ...customTypographyVariants.labelSmall,
      borderColor: palette.white,
      color: palette.white,
      borderRadius: '.125re',
      padding: '8px 12px'
    }
  },
  'Mui-BodyContent-BottomText': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '800px',
      justifyContent: 'center',
      '@media (max-width: 960px)': {
        justifyContent: 'flex-end'
      }
    }
  },
  'Mui-BodyContent-Large': {
    root: {
      height: 'auto',
      maxWidth: '800px',
      '@media (max-width: 600px)': {
        width: 'calc(100% + 48px)'
      }
    }
  },
  'Mui-BodyContent-Success': {
    root: {
      width: '100%',
      backgroundColor: palette.white,
      padding: '24px',
      maxWidth: '800px'
    }
  },
  'Mui-Section-PaddingLess': {
    root: {
      padding: '0 !important'
    }
  },
  'Mui-Headline-PaddingLess': {
    root: {
      ...typographyVariants.h1,
      paddingBottom: '4px !important',
      margin: 0,

      '@media (max-width: 768px)': {
        fontSize: 22
      }
    }
  },
  'Mui-Headline-Transition': {
    root: {
      color: palette.white,
      ...typographyVariants.h1,
      '@media (max-width: 600px)': {
        marginBottom: '-28px'
      },

      '@media (max-width: 768px)': {
        fontSize: 22
      }
    }
  },
  'Mui-FabBase-Transition': {
    default: {
      backgroundColor: palette.drsBlue[700],
      color: palette.white,
      borderRadius: '.125rem',
      '&:hover': {
        background: `${palette.drsBlue[900]} !important`,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: palette.drsBlue[700]
        }
      },
      '&:active': {
        background: `${palette.drsBlue[700]} !important`
      }
    }
  }
};
const keyValuePairs = {
  'Mui-KeyValuePair': {
    key: {
      ...customTypographyVariants.sh2
    },
    value: {
      ...customTypographyVariants.sh1
    }
  },
  'Mui-KeyValuePair-Variant2': {
    root: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
    key: {
      ...customTypographyVariants.bodyLarge
    },
    value: {
      ...customTypographyVariants.sh1
    }
  },
  'Mui-KeyValuePair-Variant3': {
    root: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
    key: {
      ...customTypographyVariants.bodyRegular
    },
    value: {
      ...customTypographyVariants.sh2
    }
  }
};

const common = {
  'Mui-SaveAndExitButton': {
    root: {
      ...customTypographyVariants.labelSmall,
      backgroundColor: 'transparent',
      border: '2px solid',
      borderColor: palette.drsBlue[900],
      color: palette.drsBlue[900],
      borderRadius: '.125rem',
      padding: '8px 12px',
      '&:hover': {
        backgroundColor: `${palette.drsBlue[50]} !important`,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&:active': {
        backgroundColor: `${palette.drsBlue[50]} !important`
      }
    }
  },
  'Mui-ChipLabel': {
    root: {
      ...customTypographyVariants.labelSmall,
      padding: '3px 4px',
      borderRadius: '.125rem !important',
      height: 'inherit',
      '&$error': {
        background: palette.drsRed[50],
        color: palette.drsRed[500]
      },
      '&$info': {
        background: palette.drsBlue[50],
        color: palette.drsBlue[500]
      },
      '&$warning': {
        background: palette.drsYellow[50],
        color: palette.drsYellow[500]
      },
      '&$success': {
        background: palette.drsGreen[50],
        color: palette.drsGreen[500]
      }
    },
    label: {
      padding: 0
    }
  }
};

const layout = {
  'Mui-Body': {
    root: {
      background: palette.white
      // background: palette.keleGray.light
    }
  },

  'Mui-Footer1': {
    root: {
      backgroundColor: 'transparent',
      padding: '16px 16px 8px !important',
      // borderTop: `1px solid ${palette.mrNavy[100]}`,
      height: 'auto',
      '@media (min-width: 1024px)': {
        left: '354px',
        width: 'calc(100% - 354px)'
      }
    }
  },

  'Mui-Body-Carousel': {
    root: {
      // background: palette.mrNavy[50]
    }
  },

  'Mui-TopNavigation': {
    root: {
      background: palette.white
    }
  },

  // For Modal backdrop
  MuiBackdrop: {
    root: {
      backgroundColor: 'rgba(11, 24, 55, 0.8)'
    }
  }
};

const body = {
  'Mui-BodyContent': {
    root: {
      maxWidth: '800px'
    }
  },
  'Mui-Section': {
    root: {
      '&:last-child': {
        '@media (max-width: 600px)': {
          paddingBottom: '128px'
        }
      }
    }
  }
};

const footerNavigation = {
  'Mui-FooterContent': {
    root: {
      display: 'flex',
      flexDirection: 'column-reverse',
      maxWidth: '800px',
      '& > *:not(:first-child)': {
        marginBottom: '8px'
      },
      '@media (min-width: 600px)': {
        flexDirection: 'row',
        alignItems: 'center',
        '& > *:not(:last-child)': {
          marginRight: '16px'
        },
        '& > *:not(:first-child)': {
          margin: 0
        }
      }
    }
  },
  'Mui-FabBase': {
    root: {
      ...customTypographyVariants.sh2
    },
    default: {
      background: palette.drsBlue[900],
      border: '2px solid transparent',
      borderRadius: '.125rem',
      color: palette.white,
      '@media (pointer: fine)': {
        '&:hover': {
          boxShadow: shadows[4],
          background: palette.drsBlue[700],
          color: palette.white,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            color: palette.white,
            background: palette.drsBlue[900]
          }
        }
      },
      '&:active': {
        boxShadow: shadows[4]
      }
    },
    inverse: {
      border: `1px solid ${palette.drsGray.body}`
    },
    fabExtended: {
      height: '56px',
      '&$ghost': {
        height: '40px'
      }
    },
    fabDisabled: {
      backgroundColor: `${palette.drsGray.light} !important`,
      color: `${palette.drsBlue[100]} !important`,
      '$ghost&': {
        backgroundColor: 'transparent !important',
        color: `${palette.drsBlue[100]} !important`
      }
    },
    fabFocusVisible: {
      border: `3px solid ${palette.drsBlue[300]}`
    },
    ghost: {
      backgroundColor: 'transparent',
      color: palette.drsBlue[900],

      '&:hover': {
        backgroundColor: palette.white,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&:active': {
        backgroundColor: 'transparent'
      }
    }
  }
};

const topNavigation = {
  'Mui-LogoTopNav': {
    logo: {
      width: '150px'
    }
  }
};

const leftPanel = {
  'Mui-LeftPanel': {
    root: {
      background: palette.white,
      width: '354px'
    }
  },
  'Mui-ExperienceProgressContainer': {
    root: {
      marginTop: '24px',
      marginLeft: '-16px',
      width: '354px',
      boxSizing: 'border-box'
    }
  },
  'Mui-ProgressStage': {
    root: {
      padding: '0 28px',
      alignItems: 'center',
      marginBottom: '16px',
      '& path': {
        fill: palette.drsBlue[900]
      }
    },
    stepActive: {
      backgroundColor: palette.drsBlue[50],
      '& path': {
        fill: palette.white
      }
    },
    stepCompleted: {
      '& path': {
        fill: 'none',
        stroke: palette.drsYellow[500]
      }
    },
    label: {
      // ...typography.caption,
      color: palette.drsBlue[900],
      ...customTypographyVariants.bodyLarge,
      '$stepActive &': {
        color: palette.white
      },
      '$stepCompleted &': {
        color: palette.drsGray.body
      }
    }
  }
};

const prompt = {
  /**
   *
   * All of these are pulled from Figma but feel
   * small and "off", but it's a starting point. :)
   *
   */
  'Mui-Headline': {
    root: {
      ...typographyVariants.h1,
      color: palette.drsBlue[900],
      margin: 0,
      paddingBottom: '24px',

      '@media (max-width: 768px)': {
        fontSize: 22
      }
    }
  },

  'Mui-Description': {
    root: {
      ...customTypographyVariants.bodyLarge,
      color: palette.drsGray.main,
      margin: 0,
      paddingBottom: '8px'
    },
    link: {
      ...customTypographyVariants.bodyLargeMedium,
      color: palette.drsBlue[700],
      textDecoration: 'none',
      transition: 'color .250s',
      '@media (pointer: fine)': {
        '&:hover': {
          filter: 'brightness(92%)'
        }
      }
    },
    unstyledButton: {
      color: palette.drsBlue[700],
      ...customTypographyVariants.bodyLargeMedium
    }
  },

  'Mui-ModalLink': {
    root: {
      ...customTypographyVariants.bodyLargeMedium,
      color: palette.drsGray.body,
      margin: 0,
      paddingBottom: '8px'
    },
    link: {
      ...customTypographyVariants.bodyLargeMedium,
      color: palette.drsBlue[700],
      textDecoration: 'none',
      transition: 'color .250s',
      '@media (pointer: fine)': {
        '&:hover': {
          filter: 'brightness(92%)'
        }
      }
    }
  }
};

const popOuts = {
  // 'Mui-SnackbarLongBase': {
  //   snackbar: {
  //     background: palette.ycGreen[500],
  //   },
  //   body: {
  //     ...typography.body2,
  //   },
  // },
  'Mui-SimpleModal': {
    root: {
      padding: '24px'
    },
    header: {
      borderBottom: 'none',
      padding: 0
    },
    closeButton: {
      alignSelf: 'flex-end',
      // height: 24,
      // width: 24,
      '& svg': {
        fill: 'red'
      }
    },
    headerTitle: {
      color: palette.drsBlue[900],
      ...typographyVariants.h2,
      paddingBottom: '16px'
    },
    content: {
      color: palette.drsGray.main,
      ...customTypographyVariants.bodyLarge,
      padding: '0 0 24px',
      textAlign: 'justify',
      '& p:first-child': {
        marginTop: 0
      },
      '& p:last-child': {
        marginBottom: 0
      },
      '& a': {
        textDecoration: 'none',
        fontWeight: 500,
        color: palette.drsBlue[700],
        ...customTypographyVariants.bodyLargeMedium
      }
    },
    closeButtonFooter: {
      background: palette.drsBlue[900],
      border: '2px solid transparent',
      borderRadius: '.125rem',
      color: palette.white,
      '@media (pointer: fine)': {
        '&:hover': {
          background: palette.drsBlue[700]
        }
      }
    }
  }
};

const responseAtoms = {
  'Mui-CardAtom': {
    root: {
      border: `2px solid ${palette.drsGray.body}`
    },
    checkedCard: {
      border: `2px solid ${palette.drsYellow[500]} !important`
    },
    topRow: {
      marginBottom: '-2px'
    },
    topLeftValue: {
      ...customTypographyVariants.bodyLargeMedium
    },
    topRightValue: {
      ...customTypographyVariants.bodyLarge
    },
    bottomLeftValue: {
      ...customTypographyVariants.labelSmall,
      color: palette.drsGray.body
    },
    bottomRightValue: {
      ...customTypographyVariants.labelSmall,
      color: palette.drsGray.body
    },
    stacked: {
      boxShadow: `0 10px 0 -6px ${palette.drsGray.body}`
    },
    grouped: {
      border: `1px solid ${palette.drsGray.body}`
    }
  },
  'Mui-CheckboxInput': {
    input: {
      '& path': {
        color: palette.drsGray.body
      }
    },
    colorPrimaryCheckbox: {
      '&$checkedCheckbox': {
        '& path': {
          color: `${palette.drsYellow[500]}`
        }
      }
    }
  },
  'Mui-RadioInput': {
    colorPrimaryRadio: {
      '&$checkedRadio': {
        color: palette.drsYellow[500]
      }
    }
  },
  'Mui-SingleSelectBase': {
    root: {
      '& .MuiInput-underline': {
        '&:hover:not(.Mui-disabled)::before': {
          borderBottom: `2px solid ${palette.drsBlue[900]}`
        },
        '&:before': {
          borderBottom: `1px solid ${palette.drsGray.main}`
        },
        '&:after': {
          borderBottom: `2px solid ${palette.drsYellow[500]}`
        }
      }
    },
    label: {
      color: palette.drsBlue[900]
    },
    placeholder: {
      color: `${palette.drsGray.body}`
    },
    input: {
      color: `${palette.drsGray.main} !important`
    },
    inputIcon: {
      fill: palette.drsGray.main
    },
    menu: {
      boxShadow: shadows[4],
      borderRadius: '.125rem'
    },
    menuItem: {
      color: palette.drsGray.main,
      '@media (pointer: fine)': {
        '&:hover': {
          background: `${palette.drsBlue[900]} !important`,
          color: palette.white
        }
      },
      '&:focus:not(:hover)': {
        border: `2px solid ${palette.drsYellow[500]} !important`,
        color: palette.drsBlue[900]
      }
    },
    menuItemSelected: {
      background: `${palette.drsBlue[900]} !important`,
      color: `${palette.white} !important`
    },
    itemPrimaryText: {
      ...customTypographyVariants.bodyLarge
    },
    itemSecondaryText: {
      color: palette.drsGray.body
    }
  },
  'Mui-TypeInBase': {
    root: {
      '& .Mui-error': {
        color: palette.drsRed[500],
        '&:after': {
          borderBottomColor: palette.drsRed[500]
        }
      },
      '& .MuiSvgIcon-root': {
        '& path': {
          fill: palette.drsGray.main
        }
      }
    },
    label: {
      color: palette.drsBlue[900]
    },
    input: {
      color: `${palette.drsGray.main} !important`,
      caretColor: palette.drsYellow[500],
      '&:before': {
        borderBottom: `1px solid ${palette.drsGray.body}`
      },
      '&:after': {
        borderBottom: `2px solid ${palette.drsYellow[500]}`
      },
      '& ::placeholder': {
        color: palette.drsGray.body,
        opacity: 1
      }
    },
    underline: {
      '&:hover:not(.Mui-disabled)::before': {
        borderBottom: `2px solid ${palette.drsGray.main}`
      }
    }
  },
  'Mui-TileButtonBase': {
    root: {
      background: 'transparent',
      border: `2px solid ${palette.drsYellow[500]}`,
      borderRadius: '.125rem',
      color: palette.drsBlue[900],
      '@media (pointer: fine)': {
        '&:hover': {
          boxShadow: shadows[4]
        }
      }
    },
    selectedOption: {
      background: palette.drsYellow[500],
      color: palette.white,
      '.multi-select &': {
        background: palette.drsYellow[500],
        border: `2px solid ${palette.drsYellow[500]}`,
        boxShadow: `0 0 0 1px ${palette.drsYellow[100]}`,
        '@media (pointer: fine)': {
          '&:hover': {
            boxShadow: shadows[4]
          }
        }
      }
    },
    buttonLabel: {
      ...customTypographyVariants.bodyLargeMedium
    }
  }
};

const list = {
  'Mui-List': {
    root: {
      color: palette.drsBlue[900],
      marginBottom: '44px',
      textAlign: 'center'
    },
    listContainer: {
      backgroundColor: palette.drsGray.light,
      display: 'inline-block',
      padding: '16px 24px',
      textAlign: 'left'
    }
  }
};

const progress = {
  'Mui-ProgressBar': {
    root: {
      margin: '-24px 0 32px'
    }
  }
};

const visual = {
  'Mui-Image': {
    root: {
      margin: '-32px 0 24px'
    }
  },
  'Mui-ParsedHTML': {
    root: {
      fontFamily: fontStack.openSans,
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px',
      color: palette.drsGray.main,
      '& a': {
        fontFamily: fontStack.openSans,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '18px',
        color: palette.drsBlue[700],
        textDecoration: 'none',
        transition: 'color .250s',
        '@media (pointer: fine)': {
          '&:hover': {
            filter: 'brightness(92%)'
          }
        }
      }
    }
  }
};

export const overrides = {
  ...variants,
  ...keyValuePairs,
  ...common,
  ...layout,
  ...body,
  ...topNavigation,
  ...footerNavigation,
  ...leftPanel,
  ...prompt,
  ...popOuts,
  ...responseAtoms,
  ...list,
  ...visual,
  ...progress
};
